<vectronic-filter-header
  (titleClicked)="toggleFilter()"
  [title]="'Process ID Order'"
  (enabledFilterToggle)="toggleFilter()"
  [isFilterEnabled]="!isFilterHidden()"
></vectronic-filter-header>
<div class="filter-body" [hidden]="isFilterHidden()">
  <vectronic-chips-autocomplete
    [selectedItems]="selectedFilterItems()"
    [items]="availableFilterItems$ | async"
    (selectItem)="onSelectFilterItem($event)"
    (deleteItem)="onDeleteFilterItem($event)"
    [enableAdd]="false"
    [enableConfirmationOnRemove]="false"
    (textChange)="filterTextChanged($event)"
  ></vectronic-chips-autocomplete>
</div>
